import { createContext, useContext } from 'react';

export const AccessContext = createContext({});
export const useAccessContext = () => {
    const context = useContext(AccessContext);
    if (!context) {
        throw new Error('AccessContext cannot be used outside the AccessProvider')
    }
    return context;
}
